import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KanziInventoryBarChartComponent } from './components/kanzi-inventory-bar-chart/kanzi-inventory-bar-chart.component';
import { KanziLocationsBarChartComponent } from './components/kanzi-locations-bar-chart/kanzi-locations-bar-chart.component';
import { KanziMantainanceRevisionsCountComponent } from './components/kanzi-mantainance-revisions-count/kanzi-mantainance-revisions-count.component';
import { KanziPrintedItemsCountComponent } from './components/kanzi-printed-items-count/kanzi-printed-items-count.component';
import { KanziReturnsItemsCountComponent } from './components/kanzi-returns-items-count/kanzi-returns-items-count.component';
import { KanziSalesComparativeChartComponent } from './components/kanzi-sales-comparative-chart/kanzi-sales-comparative-chart.component';
import { KanziSalesFloormapChartComponent } from './components/kanzi-sales-floormap-chart/kanzi-sales-floormap-chart.component';
import { KanziSalesTreemapChartComponent } from './components/kanzi-sales-treemap-chart/kanzi-sales-treemap-chart.component';
import { KanziSellItemsCountComponent } from './components/kanzi-sell-items-count/kanzi-sell-items-count.component';
import { KanziTracesLineChartComponent } from './components/kanzi-traces-line-chart/kanzi-traces-line-chart.component';
import { KanziValidationItemsCountComponent } from './components/kanzi-validation-items-count/kanzi-validation-items-count.component';
import { TranslateModule } from '@ngx-translate/core';
import { KanziUiModule } from '@kanzi-apes/kanzi-ui';
import { KanziPrimeUiModule } from '@kanzi-apes/kanzi-prime-ui';
import { FormsModule } from '@angular/forms';
import { KanziFloormapUiModule } from '@kanzi-apes/kanzi-floormap-ui';
import {NgxEchartsModule} from "ngx-echarts";

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    KanziUiModule,
    KanziPrimeUiModule,
    FormsModule,
    KanziFloormapUiModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    })
  ],
  declarations: [
    KanziInventoryBarChartComponent,
    KanziLocationsBarChartComponent,
    KanziMantainanceRevisionsCountComponent,
    KanziPrintedItemsCountComponent,
    KanziReturnsItemsCountComponent,
    KanziSalesComparativeChartComponent,
    KanziSalesFloormapChartComponent,
    KanziSalesTreemapChartComponent,
    KanziSellItemsCountComponent,
    KanziTracesLineChartComponent,
    KanziValidationItemsCountComponent,
  ],
  exports: [
    KanziInventoryBarChartComponent,
    KanziLocationsBarChartComponent,
    KanziMantainanceRevisionsCountComponent,
    KanziPrintedItemsCountComponent,
    KanziReturnsItemsCountComponent,
    KanziSalesComparativeChartComponent,
    KanziSalesFloormapChartComponent,
    KanziSalesTreemapChartComponent,
    KanziSellItemsCountComponent,
    KanziTracesLineChartComponent,
    KanziValidationItemsCountComponent,
  ],
})
export class KanziAnalyticsModule {}
